import type { VideoPlayerWrapperProps } from 'components/common/VideoPlayer/VideoPlayerWrapper.types';
import VideoPlayer from 'components/common/VideoPlayer/VideoPlayer';
import useMartyContext from 'hooks/useMartyContext';
import { isValidMartyPath } from 'helpers/LocationUtils';

const VideoPlayerWrapper = (props: VideoPlayerWrapperProps) => {
  const {
    slotName,
    slotIndex,
    slotDetails: {
      poster,
      tabletPoster,
      mobilePoster,
      src,
      tabletVideoSrc,
      mobileVideoSrc,
      variant = 'outlinedReversed',
      controls = false,
      muted = true,
      autoPlay = true,
      loop = true,
      playsInline = true,
      content: { heading, copy, cta, url, placement, backgroundColor } = {},
      videoCtaUrl
    } = {}
  } = props;

  const { router } = useMartyContext();

  const shouldShowVideo = src && poster && (src || tabletVideoSrc || mobileVideoSrc);

  if (!shouldShowVideo) {
    return null;
  }

  const handleCTAAction = () => {
    router.pushPreserveAppRoot(isValidMartyPath(url ?? '') ? url : '/');
  };

  return (
    <div
      // Override legacy 16:9 padding-based aspect ratio from design library with current 21:9 aspect-ratio classes
      className="mb-4 sm:mb-8 md:mb-16 [&_div:has(>video)]:aspect-[4/5] [&_div:has(>video)]:!h-auto [&_div:has(>video)]:!pt-0 [&_div:has(>video)]:sm:aspect-[21/9]"
      data-slot-id={slotName}
      data-slotindex={slotIndex}
    >
      <VideoPlayer
        src={src}
        mobileVideoSrc={mobileVideoSrc}
        tabletVideoSrc={tabletVideoSrc}
        mobilePoster={mobilePoster}
        tabletPoster={tabletPoster}
        poster={poster}
        variant={variant}
        heading={heading}
        copy={copy}
        cta={cta}
        url={url}
        backgroundColor={backgroundColor}
        placement={placement}
        handleCTAAction={handleCTAAction}
        controls={Boolean(controls)}
        muted={Boolean(muted)}
        autoPlay={Boolean(autoPlay)}
        loop={Boolean(loop)}
        playsInline={Boolean(playsInline)}
        videoCtaUrl={videoCtaUrl}
      />
    </div>
  );
};

export default VideoPlayerWrapper;
